import React, { useState, useEffect } from "react";
import _sortBy from "lodash/sortBy";
import getConfig from "next/config";
import GalleryLightbox from "@components/ProductMedia/GalleryLightbox";
import ProductGallery from "@components/ProductMedia/ProductGallery";
import InLightboxGallery from "@components/ProductMedia/InLightboxGallery";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ProductMedia = ({ product }) => {
  const { name, seo_alt_text: altText, image, gallery } = product;

  const [currentGallerySlide, setCurrentGallerySlide] = useState(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [drop, setDrop] = useState(false);

  const [masterSwiper, setMasterSwiper] = useState();

  const toggleLightbox = () => {
    if (drop) {
      setDrop(false);
      setTimeout(() => setIsLightboxOpen(!isLightboxOpen), 450);
    } else {
      setIsLightboxOpen(!isLightboxOpen);
    }
  };

  const parseImageGallery = () => {
    let imageGallery = [];

    // Check if product image is available
    if (image) {
      let isImageinGallery = undefined;

      // Check if product image gallery is empty
      if (gallery && gallery.length > 0) {
        // Gallery not empty
        // Add gallery in imageGallery
        imageGallery = [...gallery];

        // Find if image is in gallery
        for (let galleryImage of imageGallery) {
          if (galleryImage.file === image) {
            isImageinGallery = true;
            break;
          }
        }
      }

      // If image is not in gallery add it at position 0
      if (!isImageinGallery) {
        imageGallery.push({
          file: image,
          position: 0,
        });
      }
    } else {
      imageGallery.push({
        file: `${settings.websiteStatics}/images/catalog/product/image.jpg`,
        position: 0,
      });
    }

    // Sort image gallery by position
    const sortedGallery = _sortBy(imageGallery, "position");
    return sortedGallery;
  };

  // Forcing update on the slider outside the lightbox to keep them both
  // in sync while sliding from the lightbox modal
  useEffect(() => {
    if (masterSwiper?.current) {
      const currentIndex = masterSwiper.current.swiper.activeIndex;
      if (currentIndex !== currentGallerySlide)
        masterSwiper.current.swiper.slideTo(currentGallerySlide);
    }
  }, [currentGallerySlide]);

  const imgGallery = parseImageGallery();

  return (
    <>
      <ProductGallery
        title={altText || name}
        images={imgGallery}
        onSlideClick={toggleLightbox}
        onSlideChange={setCurrentGallerySlide}
        currentSlide={currentGallerySlide}
        setMasterSwiper={setMasterSwiper}
      />

      <GalleryLightbox
        active={isLightboxOpen}
        onCloseRequest={toggleLightbox}
        drop={drop}
        setDrop={setDrop}
      >
        <InLightboxGallery
          title={altText || name}
          images={imgGallery}
          onSlideChange={setCurrentGallerySlide}
          currentSlide={currentGallerySlide}
          setDrop={setDrop}
        />
      </GalleryLightbox>
    </>
  );
};

export default ProductMedia;
